// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__17rk_","itemTitle":"ClientEmergencyInfo_itemTitle__F3rE9","itemText":"ClientEmergencyInfo_itemText__1yt6j"};